import React, { Component } from "react";
import "./Experience.scss";

class Experience extends Component {
	render() {
		return (
			<div id="experience" className="experience">
				<h3>Experience</h3>
				<div className="container col-12 col-sm-10 col-md-6 col-lg-6">
					<div className="line">
						<div className="experience-item">
							<h4>KOKOA Club Team Member</h4>
							<span>ESPOL September 2019 - present</span>
							<ul>
								<li>
									<p>
										Delegate of the administration and maintenance of computer
										equipment.
									</p>
								</li>
								<li>
									<p>
										Installation of operating systems especially Linux
										distributions.
									</p>
								</li>
								<li>
									<p>
										Organization of events: Induction to Students, Hour of Code
										and FLISoL.
									</p>
								</li>
							</ul>
						</div>

						<div className="experience-item">
							<h4>Volunteer</h4>
							<span>ZUMAR August - November 2019</span>
							<ul>
								<li>
									<p>Prepare study material.</p>
								</li>
								<li>
									<p>
										Math Teacher of children in 10th year of basic education.
									</p>
								</li>
							</ul>
						</div>

						<div className="experience-item">
							<h4>Junior Application Developer</h4>
							<span>JOBSQUARE February - March 2020</span>
							<ul>
								<li>
									<p>Mobile Application Developer for Android OS.</p>
								</li>
								<li>
									<p>Work on the User Interface.</p>
								</li>
							</ul>
						</div>

						<div className="experience-item">
							<h4>Software Engineer</h4>
							<span>Ciifen February - September 2021</span>
							<br/>
							<span>Centro Internacional para la Investigación del Fenómeno del Niño</span>
							<ul>
								<li>
									<p>Ciifen Mobile App for weather station observers</p>
								</li>
								<li>
									<p>Software Design</p>
								</li>
								<li>
									<p>Flutter Developer</p>
								</li>
							</ul>
						</div>

						<div className="experience-item">
							<h4>Frontend Developer</h4>
							<span>Ciifen - October 2021</span>
							<br/>
							<span>Centro Internacional para la Investigación del Fenómeno del Niño</span>
							<ul>
								<li>
									<p>Mobile application for the network of volunteer climate observers (Volunclima)</p>
								</li>
								<li>
									<p>Google Play Developer Console</p>
								</li>
								<li>
									<p>Android Developer</p>
								</li>
							</ul>
						</div>

						<div className="experience-item">
							<h4>Frontend Developer</h4>
							<span>Easyfix May 2021 - Present</span>
							<ul>
								<li>
									<p>Easyfix app to request technician</p>
								</li>
								<li>
									<p>Play Store and App Store Administrator</p>
								</li>
								<li>
									<p>Flutter Developer</p>
								</li>
							</ul>
						</div>

						<div className="experience-item">
							<h4>Frontend Developer</h4>
							<span>MediApp S.A November 2021 - Present</span>
							<ul>
								<li>
									<p>Mediko app for doctors</p>
								</li>
								<li>
									<p>Play Store and App Store Administrator</p>
								</li>
								<li>
									<p>Flutter Developer</p>
								</li>
							</ul>
						</div>

					</div>
				</div>
			</div>
		);
	}
}

export default Experience;
